import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { getSettingValueSelector, TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import Component, { type ContentIconComponentProps } from "./component";
import { makeStyleSelector } from "./selectors";

const makeMapStateToProps = () => {
  const styleSelector = makeStyleSelector();

  const iconSelector = getSettingValueSelector(TargetSelector.Entity, "icon");

  return (state: AppState, props: RootContainerProps): ContentIconComponentProps => {
    const icon = iconSelector(state, props);

    return {
      style: styleSelector(state, props),
      className: icon,
      ...props
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
